module.exports = __webpack_public_path__ + "img/aacc.1fdba645.jpg";